<template>
  <div class="main">
    <div class="quota-banner">
      <van-icon name="info-o" class="quota-icon" />
      <span>本月已用 {{ quotaInfo.usedCount }} 次 / 限额 {{ quotaInfo.maxQuota || 2 }} 次，剩余 {{ quotaInfo.remainingQuota }} 次；仅支持补报最近2天内行程。</span>
    </div>

    <van-form @submit="onSubmit" label-width="80" style="padding: 8px 24px">
      <van-notice-bar
        v-if="quotaInfo.usedCount >= 2 || !quotaInfo.canSubmitNormal"
        wrapable
        :scrollable="false"
        color="#ed6a0c"
        background="#fffbe8"
        left-icon="warning-o"
        text="本月正常补单已达2次上限。仍可提交：请填写下方「特殊说明」后走人工审核（与上方「原因」不同）。"
        class="quota-warning-bar"
      />
      <van-field class="formField" label="日期" v-model="form.DateTime" readonly clickable @click="showPicker = true" placeholder="点击选择日期"/>
      <van-field class="formField" label="类型">
        <template #input>
          <van-radio-group v-model="form.Type" direction="horizontal">
            <van-radio checked-color="#FEB013" name="早班车">早班车</van-radio>
            <van-radio checked-color="#FEB013" name="晚班车">晚班车</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        class="formField"
        :label="form.Type === '早班车' ? '上车地点':'下车地点'"
        v-model="form.Way"
        readonly
        clearable
        placeholder="点击选择地点"
        :rules="[{ required: true }]"
        @click="showWay = true"/>
      <van-field class="formField" label="姓名" v-model="form.Name" readonly />
      <van-field class="formField" label="工号" v-model="form.UserId" readonly />
      <van-field class="formField" label="联系方式 " v-model="form.Phone" clearable :rules="[{ required: true }]" />
      <van-field class="formField" label="司机" v-model="form.DName" readonly clickable placeholder="点击选择司机" :rules="[{ required: true }]" @click="showUser = true"/>
      <van-field class="formField" label="工号" v-model="form.DriverId" readonly placeholder="自动填写"/>
      <van-field
        class="formField"
        v-model="form.Message"
        rows="3"
        autosize
        label="原因"
        type="textarea"
        maxlength="200"
        placeholder="请输入原因"
        show-word-limit
        :rules="[{ required: true }]"
      />
      <van-switch-cell
        v-if="quotaInfo.usedCount >= 2 || !quotaInfo.canSubmitNormal"
        v-model="form.IsSpecial"
        title="申请特殊补单"
        active-color="#FEB013"
        class="formField"
      />
      <van-field
        v-if="form.IsSpecial || quotaInfo.usedCount >= 2 || !quotaInfo.canSubmitNormal"
        ref="specialReasonField"
        class="formField special-reason-field"
        v-model="form.SpecialReason"
        rows="2"
        autosize
        label="特殊说明"
        type="textarea"
        maxlength="150"
        placeholder="请详细说明补单的特殊原因（如年假、公出、系统异常等）"
        show-word-limit
        required
        :rules="[{ required: true, message: '请填写特殊原因说明' }]"
      />
      <div style="margin-top: 20px;">
        <van-button round block color="#FEB013" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showUser" position="bottom" safe-area-inset-bottom :style="{ height: '65%' }">
      <van-search v-model="searchDriver" show-action placeholder="请输入司机姓名" @search="searchUser">
        <template #action>
          <div @click="searchUser">搜索</div>
        </template>
      </van-search>
      <van-radio-group v-model="form.DriverId">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in driver_list"
            :key="item.UserId || index"
            :title="getDriverTitle(item)"
            :class="{ 'driver-full': isDriverFull(item) }"
            :clickable="!isDriverFull(item)"
            @click="toggleName(index)"
          >
            <template #label v-if="isDriverFull(item)">
              <span class="driver-full-tag">当天已满座</span>
            </template>
            <template #right-icon>
              <van-radio
                checked-color="#FEB013"
                :name="item.UserId"
                :disabled="isDriverFull(item)"
                ref="checkName"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <van-popup v-model="showWay" position="bottom" :close-on-click-overlay="false" safe-area-inset-bottom :style="{ height: '90%' }">
      <van-sticky>
        <div class="wayTitle">
          <div style="color: #999999;" @click="showWay = false">取消</div>
          <div style="color: #FEB013;" @click="onWay">确定</div>
        </div>
      </van-sticky>
      <div style="padding: 12px;" v-if="form.Type === '早班车'">
        <baidu-map>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-view class="map"></bm-view>
          <bm-driving
            location="珠海"
            :start="LngLat[0] ? LngLat[0] : WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }"
            :end="endLngLat"
            startCity="珠海"
            endCity="珠海"
            :auto-viewport="true"
            :panel="false"
            :waypoints="LngLat"
            @searchcomplete="searchcomplete"
          >
          </bm-driving>
        </baidu-map>
      </div>
      <van-search v-model="searchValue" show-action placeholder="请输入搜索公交车站关键词" @search="searchSite">
        <template #action>
          <div @click="searchSite">搜索</div>
        </template>
      </van-search>
      <van-radio-group v-model="form.Way">
        <van-cell-group>
          <van-cell
              v-for="(item, index) in way_list"
              clickable
              :key="index"
              :title="item.name"
              @click="toggleWay(index)"
          >
          <template #right-icon>
            <van-radio checked-color="#FEB013" :name="item.name" ref="checkWay" />
          </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
  </div>
</template>
<script src="https://unpkg.com/vue-baidu-map"></script>
<script>
export default {
  data() {
    return {
      form: {
        DateTime: this.$moment().format('YYYY-MM-DD'),
        Type: '早班车',
        Name: '',
        UserId: '',
        Phone: '',
        DName: '',
        DriverId: '',
        Message: '',
        Way: '',
        LngLat: [],
        Distance: 0,
        DStatus: false,
        PStatus: 1,
        IsSpecial: false,
        SpecialReason: ''
      },
      quotaInfo: {
        usedCount: 0,
        maxQuota: 2,
        remainingQuota: 2,
        canSubmitNormal: true
      },
      showPicker: false,
      minDate: this.$moment().subtract(2, 'days').toDate(),
      maxDate: new Date(),
      showUser: false,
      searchDriver: '',
      driver_list: [],
      selectedDriver: null,
      showWay: false,
      way_list: [],
      searchValue: '',
      wayData: '',
      LngLat: [],
      endLngLat: {}
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
    this.form.OpenId = this.WXInfo.openid

    this.endLngLat = this.WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }
    this.fetchQuota()
  },
  methods: {
    async fetchQuota() {
      if (!this.form.UserId) return
      try {
        const result = await this.$request({
          url: this.$api.getAbnormalQuota,
          method: 'GET',
          params: {
            UserId: this.form.UserId,
            DateTime: this.form.DateTime
          }
        })
        if (result.success && result.data) {
          this.quotaInfo = result.data
          if (this.quotaInfo.usedCount >= 2 || !this.quotaInfo.canSubmitNormal) {
            this.form.IsSpecial = true
          }
        }
      } catch (e) {
        console.error('获取补单额度失败', e)
      }
    },
    showAbnormalAlert(title, message) {
      return this.$toast.alert(message, { title: title || '提示' })
    },
    promptSpecialReason(message) {
      this.form.IsSpecial = true
      return this.showAbnormalAlert('本月补单已达上限', message || '本月正常补单已达 2 次上限。仍可提交：请向下填写「特殊说明」（与上方「原因」不同），提交后走人工审核。').then(() => {
        this.$nextTick(() => {
          const field = this.$refs.specialReasonField
          const el = field && (field.$el || field)
          if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      })
    },
    onConfirm (value) {
      this.form.DateTime = this.$moment(value).format('YYYY-MM-DD')
      this.showPicker = false
      this.selectedDriver = null
      this.form.DName = ''
      this.form.DriverId = ''
      this.driver_list = []
      this.fetchQuota()
    },
    searchUser () {
      const kw = (this.searchDriver || '').trim()
      if (!kw) {
        this.$toast('请输入司机姓名')
        return
      }
      if (this.form.Type === '早班车') {
        this.getWorkDriverInfo(kw)
      } else {
        this.getHomeDriverInfo(kw)
      }
    },
    async toggleName (index) {
      const item = this.driver_list[index]
      if (this.isDriverFull(item)) {
        this.$toast('该司机当天已满座，无法选择')
        return
      }
      await this.$refs.checkName[index].toggle()
      this.selectedDriver = item
      this.form.DName = item.Name
      this.form.DriverId = item.UserId
      this.showUser = false
    },
    getDriverTitle (item) {
      return `${item.Name || ''} ${item.CarNum || ''}`.trim()
    },
    isDriverFull (item) {
      if (!item || item.CarSeat == null) return false
      const seats = Number(item.CarSeat) || 0
      if (seats <= 0) return false
      // 当天未发起行程时不算满座，异常补单仍可选
      if (item.hasTrip === false) return false
      const count = item.passengerCount != null
        ? item.passengerCount
        : (item.passengers ? item.passengers.length : 0)
      return count >= seats
    },
    onWay () {
      this.form.Way = this.wayData
      this.form.LngLat = this.LngLat
      this.showWay = false
    },
    searchcomplete (value) {
      if (value.taxiFare) {
        this.form.Distance = value.taxiFare.distance
      }
    },
    async toggleWay (index) {
      await this.$refs.checkWay[index].toggle()
      this.wayData = this.way_list[index].name
      this.LngLat = [this.way_list[index].location]
    },
    searchSite () {
      this.getSiteList(this.searchValue)
    },
    async havingData(val) {
      let status = false
      let result = await this.$request({
        url: val.Type === '早班车' ? this.$api.getWorkTravelFromPassenger : this.$api.getPassengerByOpenid,
        method: 'GET',
        params: {
          UserId: val.UserId,
          DateTime: val.DateTime
        }
      })
      if (JSON.stringify(result.data) !== "[]") {
        status = true
      }
      return status
    },
    async onSubmit() {
      if (this.selectedDriver && this.isDriverFull(this.selectedDriver)) {
        await this.showAbnormalAlert('无法提交', '该司机当天已满座，请更换其他司机。')
        return
      }
      if ((this.quotaInfo.usedCount >= 2 || !this.quotaInfo.canSubmitNormal) && (!this.form.IsSpecial || !this.form.SpecialReason || !this.form.SpecialReason.trim())) {
        await this.promptSpecialReason()
        return
      }

      let having = await this.havingData(this.form)
      if (having) {
        await this.showAbnormalAlert('无法提交', '当前日期已有拼车记录，无需重复提交。')
        return
      }
      const result = await this.postAbnormal(this.form)
      if (result.success) {
        let message = (this.form.IsSpecial ? '【特殊补单】' : '') + '补单通知：' +
          '\n\n日期：' + this.form.DateTime +
          '\n类型：' + this.form.Type +
          '\n乘客：' + this.form.Name +
          '\n手机号码：' + this.form.Phone +
          '\n地点：' + this.form.Way + 
          (this.form.IsSpecial && this.form.SpecialReason ? ('\n特殊原因：' + this.form.SpecialReason) : '') +
          '\n\n有乘客提交补单申请，请确认审核。\n\n' +
          '<a href="https://pinche.jafron.com/work/audit">审核</a>'
        this.postSendMessage(this.form.DriverId, message)
        this.$toast('提交成功')
        this.$router.push('/home')
      } else if (result.needSpecialReason) {
        await this.promptSpecialReason(result.message)
      } else {
        await this.showAbnormalAlert('提交失败', result.message || '提交失败，请稍后重试')
      }
    },
    async getSiteList(value) {
      const result = await this.$request({
        url: this.$api.getBaiDuSiteList,
        method: 'GET',
        params: {
          name: value
        }
      })
      if (result.data.length > 0) {
        let obj = {}
        this.way_list = result.data.reduce((item, next) => {
          obj[next.name] ? '' : obj[next.name] = true && item.push(next)
          return item
        }, [])
      } else {
        this.$toast(result.message)
      }
    },
    postAbnormal(data) {
      return this.$request({
        url: this.$api.postAbnormal,
        method: 'POST',
        params: {
          DateTime: data.DateTime,
          UserId: data.UserId,
          Type: data.Type,
          type: 'create'
        },
        data
      })
    },
    async getWorkDriverInfo(val) {
      const kw = (val || '').trim()
      if (!kw) {
        this.driver_list = []
        return
      }
      const params = {
        Role: 'driver',
        Effictive: true,
        Status: true,
        onlyAvailable: false,
        DateTime: this.form.DateTime,
        keyword: kw
      }
      const result = await this.$request({
        url: this.$api.getWorkDriverList,
        method: 'GET',
        params
      })
      this.driver_list = result.data && result.data.length ? result.data : []
    },
    async getHomeDriverInfo(val) {
      const kw = (val || '').trim()
      if (!kw) {
        this.driver_list = []
        return
      }
      const result = await this.$request({
        url: '/api/Commute/getUserInfo',
        method: 'GET',
        params: {
          Name: kw,
          Role: 'driver',
          Work: true
        }
      })
      this.driver_list = result.data && result.data.length ? result.data : []
    },
    // 发送消息
    async postSendMessage(userid, message) {
      const result = await this.$request({
        url: this.$api.postSendMessageWX,
        method: 'POST',
        data: {
          'touser': userid,
          'msgtype': 'text',
          'agentid': this.$agentid,
          'text': { 'content': message }
        }
      })
      if (!result.success) {
        this.$toast(result.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    height: inherit;
    background-color:#FFFFFF;
  }
  .quota-banner {
    display: flex;
    align-items: center;
    background-color: #FFFBE8;
    color: #FA8C16;
    border-bottom: 1px solid #FFE58F;
    padding: 10px 16px;
    font-size: 13px;
    line-height: 1.5;
  }
  .quota-icon {
    margin-right: 6px;
    font-size: 16px;
    flex-shrink: 0;
  }
  .quota-warning-bar {
    margin-bottom: 8px;
    border-radius: 4px;
    padding: 8px 12px;
  }
  .map {
    width: 100%;
    height: 200px;
  }     
  .formField {
    background-color: #F5F5F5;
    margin: 8px 0;
    border-radius: 4px;
    padding: 12px;
    font-size: 16px;
  }
  .wayTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    padding: 12px;
    background-color: #FFFFFF;
  }
  .driver-full {
    opacity: 0.55;
  }
  .driver-full-tag {
    color: #ee0a24;
    font-size: 12px;
  }
</style>
